{
  "version": 1,
  "asset_id": "2d574d1c-071c-432d-870c-13d9915e3abf",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/2d574d1c-071c-432d-870c-13d9915e3abf/google-pay.svg",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/2d574d1c-071c-432d-870c-13d9915e3abf/google-pay.svg",
  "original_filename": "google-pay.svg",
  "size": 4772,
  "content_type": "image/svg+xml",
  "created_at": "2026-08-30T15:11:38Z"
}
